import { WHATSAPP_URL } from "@/constants/contact";
import HeroVisual from "./HeroVisual";

export default function HeroSection() {
  return (
    <section
      id="hero"
      className="relative min-h-screen flex items-center overflow-hidden pt-24 pb-16"
    >
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Dark%20futuristic%20cyber%20technology%20background%20with%20neon%20teal%20cyan%20glowing%20lines%20abstract%20digital%20particles%20holographic%20UI%20elements%20deep%20black%20space%20creative%20web%20agency%20atmosphere%20cinematic&width=1920&height=1080&seq=hero-v2&orientation=landscape"
          alt=""
          className="w-full h-full object-cover opacity-40"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#030712] via-[#030712]/60 to-[#030712]" />
        <div className="absolute inset-0 bg-gradient-to-tr from-teal-500/10 via-transparent to-cyan-500/5" />
      </div>

      <div className="relative z-10 container-main px-4 md:px-8 w-full">
        <div className="grid lg:grid-cols-2 gap-12 items-center lg:items-start">
          <div className="text-center lg:text-right order-2 lg:order-1">
            <div className="inline-flex items-center gap-2 bg-teal-500/10 border border-teal-400/30 rounded-full px-5 py-2 mb-8 backdrop-blur-sm">
              <span className="relative flex h-2 w-2">
                <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-teal-400 opacity-75" />
                <span className="relative inline-flex rounded-full h-2 w-2 bg-teal-400" />
              </span>
              <span className="text-teal-300 text-sm font-medium">
                شركة برمجيات سعودية معتمدة
              </span>
            </div>

            <h1 className="text-4xl md:text-5xl lg:text-6xl xl:text-7xl font-extrabold leading-[1.15] mb-6">
              <span className="title-line-1 text-white">صمّم موقعك</span>
              <span className="title-line-2 v2-gradient-text">
                باحتراف مع أوامر الشبكة
              </span>
            </h1>

            <p className="text-slate-400 text-base md:text-lg max-w-xl mx-auto lg:mx-0 lg:mr-0 mb-10 leading-relaxed">
              مواقع إلكترونية سريعة، آمنة، متجاوبة مع الجوال، ومهيأة لمحركات
              البحث لتساعد مشروعك على الظهور، بناء الثقة، وزيادة العملاء.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center lg:justify-start gap-4">
              <a
                href="#cta"
                onClick={(e) => {
                  e.preventDefault();
                  document
                    .querySelector("#cta")
                    ?.scrollIntoView({ behavior: "smooth" });
                }}
                className="v2-cta-primary w-full sm:w-auto"
              >
                <i className="ri-calendar-check-line text-lg" />
                احصل على استشارة مجانية
              </a>
              <a
                href={WHATSAPP_URL}
                target="_blank"
                rel="noopener noreferrer"
                className="v2-cta-whatsapp w-full sm:w-auto"
              >
                <i className="ri-whatsapp-line text-lg" />
                تواصل عبر واتساب
              </a>
            </div>
          </div>

          <div className="order-1 lg:order-2 relative hidden md:block w-full">
            <HeroVisual />
          </div>
        </div>
      </div>

      <div className="absolute bottom-8 left-1/2 -translate-x-1/2 flex flex-col items-center gap-2 text-slate-500 animate-bounce">
        <span className="text-xs">اكتشف المزيد</span>
        <i className="ri-arrow-down-line" />
      </div>
    </section>
  );
}
